<template>
  <div @click="goto" id="app-index">
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  methods:{
      goto(){
          this.$router.push({name:'largerDonations2'})
      }
  }
};
</script>

<style lang="less" scoped>
#app-index {
  width: 100vw;
  height: 100vh;
  background: url("../../assets/images/first.png") no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/donation/first.vue